/** Figma footer — mobile 76:3496, desktop 54:3782 */
import { HOME_MOBILE_MQ, homeMobilePaddingX } from '../home/homeMobileLayout'

export const footerPaddingX = homeMobilePaddingX

export const footerPaddingY = {
  xs: '32px',
  sm: 6,
  md: 8,
  lg: '80px',
}

export const footerSectionGap = {
  xs: '32px',
  md: '40px',
  lg: '58px',
}

export const footerColumnGap = {
  xs: '32px',
  md: '60px',
  lg: '100px',
}

export const footerBrandGap = {
  xs: '32px',
  lg: '32px',
}

export { HOME_MOBILE_MQ as FOOTER_MOBILE_MQ }
